export async function getUserDeviceDetails() {
  const screenResolution = getScreenResolution();
  const userAgent = navigator.userAgent;
  const ipAddress = await getDeviceIp();

  const deviceInfo = {
    user_agent: userAgent,
    ip: ipAddress, // The user's IP cannot be obtained directly in the browser for privacy reasons.
    browser: getBrowser(),
    device: getDeviceModel(),
    flowType: getFlowType(window.location.href),
    os: getOS(),
    os_version: getOSVersion(),
    orientation: getDeviceOrientation(),
    isMobile: /Mobi|Android/i.test(navigator.userAgent),
    isDesktop:
      !/Mobi|Android/i.test(navigator.userAgent) &&
      !/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(
        navigator.userAgent.toLowerCase()
      ),
    isTablet: /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(
      navigator.userAgent.toLowerCase()
    ),
    screen: `{"width": ${screenResolution.width}, "height": ${screenResolution.height}}`,
  };

  return deviceInfo;
}

async function getDeviceIp() {
  // Try to get the IP through a public API (may fail due to CORS or availability)
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (error) {
    return "Not available";
  }
}

function getFlowType(url) {
  const urlParts = url.split("/");
  const widgetIndex =
    urlParts.indexOf("widget") === -1
      ? urlParts.indexOf("widget-boxed")
      : urlParts.indexOf("widget");

  if (widgetIndex !== -1 && widgetIndex + 1 < urlParts.length) {
    return urlParts[widgetIndex + 1];
  } else {
    return null;
  }
}

function getScreenResolution() {
  return {
    width: window.screen.width,
    height: window.screen.height,
  };
}

function getDeviceOrientation() {
  return screen.orientation
    ? screen.orientation.type
    : window.innerWidth > window.innerHeight
    ? "landscape"
    : "portrait";
}

function getOS() {
  const userAgent = navigator.userAgent;
  let operativeSystem = "Unknow";

  if (userAgent.indexOf("Windows") !== -1) {
    operativeSystem = "Windows";
  } else if (
    userAgent.indexOf("Mac OS X") !== -1 ||
    userAgent.indexOf("Macintosh") !== -1
  ) {
    operativeSystem = "macOS";
  } else if (userAgent.indexOf("Linux") !== -1) {
    operativeSystem = "Linux";
  } else if (userAgent.indexOf("Android") !== -1) {
    operativeSystem = "Android";
  } else if (userAgent.indexOf("iOS") !== -1) {
    operativeSystem = "iOS";
  } else if (userAgent.indexOf("CrOS") !== -1) {
    operativeSystem = "Chrome OS";
  } else if (userAgent.indexOf("WinCE") !== -1) {
    operativeSystem = "Windows CE";
  }

  return operativeSystem;
}

function getOSVersion() {
  const userAgent = navigator.userAgent;
  let osVersion = "Unknow";

  if (userAgent.indexOf("Windows NT 10.0") !== -1) {
    osVersion = "Windows 10";
  } else if (userAgent.indexOf("Windows NT 6.3") !== -1) {
    osVersion = "Windows 8.1";
  } else if (userAgent.indexOf("Windows NT 6.2") !== -1) {
    osVersion = "Windows 8";
  } else if (userAgent.indexOf("Windows NT 6.1") !== -1) {
    osVersion = "Windows 7";
  } else if (userAgent.indexOf("Windows NT 6.0") !== -1) {
    osVersion = "Windows Vista";
  } else if (userAgent.indexOf("Windows NT 5.1") !== -1) {
    osVersion = "Windows XP";
  } else if (userAgent.indexOf("Windows NT 5.0") !== -1) {
    osVersion = "Windows 2000";
  } else if (userAgent.indexOf("Mac OS X 10_") !== -1) {
    const versionMatch = userAgent.match(/Mac OS X 10_([0-9_]+)/);
    if (versionMatch && versionMatch[1]) {
      osVersion = "macOS " + versionMatch[1].replace(/_/g, ".");
    } else {
      osVersion = "macOS";
    }
  } else if (userAgent.indexOf("Linux") !== -1) {
    osVersion = "Linux";
  } else if (userAgent.indexOf("Android") !== -1) {
    const versionMatch = userAgent.match(/Android ([0-9.]+)/);
    if (versionMatch && versionMatch[1]) {
      osVersion = "Android " + versionMatch[1];
    } else {
      osVersion = "Android";
    }
  } else if (
    userAgent.indexOf("iOS") !== -1 ||
    userAgent.indexOf("Mac OS") !== -1
  ) {
    const versionMatch = userAgent.match(/OS ([0-9_]+) like Mac OS X/);
    if (versionMatch && versionMatch[1]) {
      osVersion = "iOS " + versionMatch[1].replace(/_/g, ".");
    } else {
      osVersion = "iOS";
    }
  }

  return osVersion;
}

function getDeviceModel() {
  const userAgent = navigator.userAgent;
  let model = "Unknow";

  const models = [
    { pattern: /iPhone/i, model: "iPhone" },
    { pattern: /iPad/i, model: "iPad" },
    { pattern: /Android/i, model: "Android Device" },
    { pattern: /SamsungBrowser\/([0-9.]+)/i, model: "Samsung" },
    { pattern: /HuaweiBrowser\/([0-9.]+)/i, model: "Huawei" },
    { pattern: /OPR\/([0-9.]+).*Mobile/i, model: "Opera Mobile" },
    { pattern: /MiuiBrowser\/([0-9.]+)/i, model: "Xiaomi" },
    { pattern: /LG-?([A-Za-z0-9]+)/i, model: "LG" },
    { pattern: /HTC ([A-Za-z0-9]+)/i, model: "HTC" },
    { pattern: /Nexus ([0-9]+)/i, model: "Nexus" },
    { pattern: /Pixel ([0-9]+)/i, model: "Pixel" },
    { pattern: /Windows Phone ([\d.]+)/i, model: "Windows Phone" },
    { pattern: /Kindle Fire/i, model: "Kindle Fire" },
    { pattern: /Silk/i, model: "Amazon Silk" },
    { pattern: /Windows /i, model: "Desktop" },
  ];

  for (const item of models) {
    if (item.pattern.test(userAgent)) {
      const match = userAgent.match(item.pattern);
      if (match && match[1]) {
        model = `${item.model} ${match[1]}`;
      } else {
        model = item.model;
      }
      break; // Stop at the first match
    }
  }

  return model;
}

function getBrowser() {
  const userAgent = navigator.userAgent;
  let browser = "Desconocido";

  if (
    userAgent.indexOf("Chrome") !== -1 &&
    userAgent.indexOf("Safari") !== -1
  ) {
    browser = "Chrome";
  } else if (userAgent.indexOf("Firefox") !== -1) {
    browser = "Firefox";
  } else if (userAgent.indexOf("Safari") !== -1) {
    browser = "Safari";
  } else if (userAgent.indexOf("Edge") !== -1) {
    browser = "Edge";
  } else if (
    userAgent.indexOf("Opera") !== -1 ||
    userAgent.indexOf("OPR/") !== -1
  ) {
    browser = "Opera";
  } else if (userAgent.indexOf("Trident") !== -1) {
    browser = "Internet Explorer";
  }

  return browser;
}